export const commonSingleTab = (FOUNDATIONS) => ({
    padding: FOUNDATIONS.spacing_200,
    gap: FOUNDATIONS.spacing_150,
    cursor: 'grab',
    min_width: FOUNDATIONS.size_800,
    max_width: FOUNDATIONS.size_1100,
    width: FOUNDATIONS.size_1100,
    border_right_width: FOUNDATIONS.size_38,
    border_right_style: 'solid',
    border_right_color: FOUNDATIONS.color_neutral_border_160,
    border_bottom_width: FOUNDATIONS.size_50,
    border_bottom_style: 'solid',
    display: 'flex',
    align_items: 'center',
    white_space: 'nowrap',
    overflow: 'hidden',
    box_sizing: 'border-box',
});
//# sourceMappingURL=commonStyles.js.map